// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_pageCms{
    background-color: #f9f9f9; /* Light background color */
    border: 1px solid #ddd; /* Border */
    padding: 10px 20px;
    margin: 0px 20px;
    height: calc(100vh - 5rem); /* Subtract 5rem from 100vh */
    overflow-y: auto; /* Allow vertical scrolling */
    border-radius: 10px;
}
.containerCms{
    border-radius: 5px;
    background-color: #f0f0f0;
    padding: 2px;
    padding-left: 5px; 
    margin-bottom: 5px;
}
.containerCms >h6 {
    font-size: medium;
}
.CreateCareer{
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    
    width: 100%;
}


.form_left{
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    gap: 1rem;
}
.form_left>*{
    border: none !important;
    width: 100% !important;
}


.form_right{
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
    gap: 1rem;


}

.input_btn{
    width: 100% !important;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.input_btn>:nth-child(1){
    width: 90%;
}
.input_btn>:nth-child(2){
    width: 10%;
    font-size: 2rem;
    cursor: pointer;
    color: var(--white);
    background-color: var(--primary_color);
    margin-left: 0.5rem;
    height: 100%;
    border-radius: 5px;

    
}
.List_of_string{
    margin-left: 2rem;
    margin-top: 2rem;
}


.TrainingRight{
    display: grid;
    grid-template-columns: 1fr;
}
.TrainingRight>:nth-child(3){
    height: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/CmsPages/HomeCmsPage/HomeCmsPage.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB,EAAE,2BAA2B;IACtD,sBAAsB,EAAE,WAAW;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B,EAAE,6BAA6B;IACzD,gBAAgB,EAAE,6BAA6B;IAC/C,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,SAAS;;;AAGb;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;;;AAGtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,0BAA0B;AAC9B;AACA;IACI,aAAa;AACjB","sourcesContent":[".home_pageCms{\n    background-color: #f9f9f9; /* Light background color */\n    border: 1px solid #ddd; /* Border */\n    padding: 10px 20px;\n    margin: 0px 20px;\n    height: calc(100vh - 5rem); /* Subtract 5rem from 100vh */\n    overflow-y: auto; /* Allow vertical scrolling */\n    border-radius: 10px;\n}\n.containerCms{\n    border-radius: 5px;\n    background-color: #f0f0f0;\n    padding: 2px;\n    padding-left: 5px; \n    margin-bottom: 5px;\n}\n.containerCms >h6 {\n    font-size: medium;\n}\n.CreateCareer{\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    \n    width: 100%;\n}\n\n\n.form_left{\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    width: 100%;\n    gap: 1rem;\n}\n.form_left>*{\n    border: none !important;\n    width: 100% !important;\n}\n\n\n.form_right{\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    width: 100%;\n    gap: 1rem;\n\n\n}\n\n.input_btn{\n    width: 100% !important;\n    flex-shrink: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.input_btn>:nth-child(1){\n    width: 90%;\n}\n.input_btn>:nth-child(2){\n    width: 10%;\n    font-size: 2rem;\n    cursor: pointer;\n    color: var(--white);\n    background-color: var(--primary_color);\n    margin-left: 0.5rem;\n    height: 100%;\n    border-radius: 5px;\n\n    \n}\n.List_of_string{\n    margin-left: 2rem;\n    margin-top: 2rem;\n}\n\n\n.TrainingRight{\n    display: grid;\n    grid-template-columns: 1fr;\n}\n.TrainingRight>:nth-child(3){\n    height: 10rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
